import goods from './goods'
import insertCustomer from './insertCustomer'
import customer from './customer'
import schedule from './schedule'
import stats from './stats'

/**
 * 加盟店的路由都放置于此
 */
export default [goods, insertCustomer, customer, schedule, stats]
